module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_bank2x.5e7e38aa.png";